import instance from "./instance";
const responseData = response => response.data;

export function getManagers(start, end, name, title, status) {
    let url = `/cms/managers?start=${start}&end=${end}`;
    if (name) {
        url += `&name=${name}`;
    }
    if (status) {
        url += `&status=${status}`;
    }
    if (title) {
        url += `&title=${title}`;
    }
    return instance
        .request({
            url,
            method: "GET",
        })
        .then(responseData);
}

export function getManager(id) {
    return instance
        .request({
            url: `/cms/managers/${id}`,
            method: "GET",
        })
        .then(responseData);
}

export function getQuestions() {
    return instance
        .request({
            url: `/cms/managers/questions`,
            method: "GET",
        })
        .then(responseData);
}

export function addImage(managerId, image, crop) {
    const formData = new FormData();
    formData.append("image", image);
    formData.append("centerX", crop.x);
    formData.append("centerY", crop.y);
    formData.append("width", crop.width);
    formData.append("height", crop.height);
    return instance
        .request({
            url: `/cms/managers/${managerId}/image`,
            method: "POST",
            data: formData,
        })
        .then(responseData);
}

export function addQuestion(question) {
    return instance
        .request({
            url: "/cms/managers/questions",
            method: "POST",
            data: {
                question,
            },
        })
        .then(responseData);
}

export function editQuestion(questionId, question) {
    return instance
        .request({
            url: `/cms/managers/questions/${questionId}`,
            method: "POST",
            data: {
                question,
            },
        })
        .then(responseData);
}

export function deleteQuestion(questionId) {
    return instance
        .request({
            url: `/cms/managers/questions/${questionId}`,
            method: "DELETE",
        })
        .then(responseData);
}

export function addQuestionResponse(managerId, questionId, response) {
    return instance
        .request({
            url: `/cms/managers/${managerId}/questions/${questionId}`,
            method: "POST",
            data: {
                response,
            },
        })
        .then(responseData);
}

export function deleteQuestionResponse(managerId, questionId) {
    return instance
        .request({
            url: `/cms/managers/${managerId}/questions/${questionId}`,
            method: "DELETE",
        })
        .then(responseData);
}
